module.exports = __webpack_public_path__ + "img/icon-password.60b9a744.svg";